import { GoArrowLeft } from "react-icons/go";
import Accordion from "react-bootstrap/Accordion";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Loader from "../../components/common/Common/Loader";
import "./Objectphotography.scss";
import replace from "../../assets/images/category/replace.png";
import { HiOutlinePlus } from "react-icons/hi";
import Tooltip from "@mui/material/Tooltip";
import React, {
  Suspense,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import toast from "react-hot-toast";
import notFound from "../../assets/images/common/image-not-found.png";
import { RiHistoryLine } from "react-icons/ri";
import { TbMessageCircleCheck } from "react-icons/tb";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  addPinObject,
  assignUser,
  cancelSession,
  createGlb,
  createObject,
  createPhotography,
  createSession,
  deletePinObject,
  getSingleObject,
  nextAndPreviousHandler,
} from "../../api/actions/object";
import { useFormik } from "formik";
import { RiCloseFill } from "react-icons/ri";
import {
  EDIT_PHOTOGRAPHY,
  GLOBAL_SEARCH,
  KANBAN_BOARD,
  LIST_CATEGORY,
  LIST_LOCATION,
  LIST_MATERIAL,
  lIST_NOTIFICATION,
  LIST_PHOTOGRAPHY,
  OBJECT_PIN,
  QR_LOCATION_MANAGMENT,
} from "../../constants/routers";
import Commentdrawer from "../object-management/commentdrawer";
import { RiVipCrownFill } from "react-icons/ri";
import {
  addItemToDB,
  clearPendingRequests,
  getPendingRequests,
} from "../../indexdb/indexdb";
import SimpleBackdrop from "../../components/common/Common/Buttonloader";
import Objecthistorydrawer from "../object-management/Objecthistorydrawer";
import star from "../../assets/images/category/star.png";
import ImageEnlarge from "../../components/common/Common/imageEnlarge";
import { listUserDropdown, usedLastScreen } from "../../api/actions/user";
import AsyncSelect from "react-select/async";
import {
  autoSaveToIndexedDB,
  clearAutoSavedFromIndexedDB,
} from "../../indexdb/autosaveIndex";
import { useSaving } from "../../store/SavinContext";
import { gets3Image } from "../../api/actions/S3sync";
import { AiOutlineCloudSync } from "react-icons/ai";
import Fileurl from "./Fileurl";
import { checkPermission } from "../../helpers/permissions";
import { Canvas } from "@react-three/fiber";
import { Bounds, Html, useGLTF } from "@react-three/drei";
import { Md3dRotation } from "react-icons/md";
import { createPortal } from "react-dom";
import NavigationAlert from "../../components/common/sweetAlert/navigationAlert";
import { useBeforeRouteChange } from "../../components/common/Common/useBeforeRoutechange";
import Swal from "sweetalert2";
import { sendSessionClose } from "../../components/common/Common/sendSessionclose";
import OverRideAlert from "../../components/common/sweetAlert/overRideAlert";
import { LuPin, LuPinOff } from "react-icons/lu";
import { GrLinkNext, GrLinkPrevious } from "react-icons/gr";
import { deepEqual } from "../../components/common/Common/deepEqual";

const Model = ({ imageUrl, instanceId }) => {
  const { scene } = useGLTF(imageUrl);
  const clonedScene = useMemo(() => scene.clone(), [scene]);

  return (
    <primitive
      scale={[0.8, 0.8, 0.8]}
      position={[0, -0.5, 0]}
      rotation={[0, Math.PI / 2, 0]}
      object={clonedScene}
    />
  );
};

const ErrorFallbackModel = () => {
  return (
    <Html zIndexRange={[0, 0]} style={{ zIndex: 1 }} center>
      <div
        style={{
          zIndex: 1,

          fontSize: "13px",
        }}
      >
        Couldn't load the 3D model
      </div>
    </Html>
  );
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (this.props.onError) this.props.onError(error, errorInfo);
    console.error("Error caught in boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || <p>Something went wrong.</p>;
    }

    return this.props.children;
  }
}

const SuspenseHtmlLoader = () => {
  return (
    <Html
      center
      zIndexRange={[0, 0]}
      distanceFactor={1}
      transform={false} // Disable 3D positioning
      style={{ zIndex: 1 }}
    >
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1,
        }}
        className="flex  items-center justify-center "
      >
        <p
          style={{
            fontSize: "13px",
          }}
        >
          Loading...
        </p>
      </div>
    </Html>
  );
};

const Objectphotographydetails = ({
  onCloseObject,
  objectId,
  fromList = false,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [folderUrl, setFolderUrl] = useState("");
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [buttonloader, setButtonloader] = useState(false);
  const [nextAndPreviousLoad, setNextAndPreviousLoad] = useState({
    next: false,
    previous: false,
  });
  const [error, setError] = useState("");
  const [isImage, setIsImage] = useState(false);
  const [isAutosave, setIsAutoSave] = useState(false);
  const [overRideMove, setOverRideMove] = useState({
    next: false,
    previous: false,
  });
  const [savedNextDigitalDataOverRide, setSavedNextDigitalDataOverRide] =
    useState();
  const [deletedImages, setDeletedImages] = useState([]);
  const [nextId, setNextId] = useState();
  const [previousId, setPreviousId] = useState();
  const [savedFormikData, setSavedFormikData] = useState(null);
  const [noGlb, setNoGlb] = useState(false);
  const [tempImage, setTempImage] = useState({
    show: false,
    data: [],
  });
  const navigate = useNavigate();
  const [user, setUser] = useState([]);
  const [isOverRide, setIsOverRide] = useState(false);
  const [isOverideLoad, setIsOverRideLoad] = useState(false);
  const [update, setUpdate] = useState();
  const [selectedGlbData, setSelectedGlbData] = useState({
    object_id: "",
    image_id: "",
    url: "",
    file: "",
    image_position: "",
    index: "",
    image_changed: false,
  });
  const [defaultUser, setDefaultUser] = useState([]);
  const [s3modal, setS3modal] = useState({
    show: false,
  });
  const [selectedUser, setSelectedUser] = useState(null);
  const [newValue, setNewValue] = useState();
  const [formikDetailData, setFormikDetailData] = useState(null);
  const location = useLocation();
  const [fromNotification] = useState(
    location.state?.fromNotification || false
  );
  const params = new URLSearchParams(window.location.search);
  const encodedState = params.get("state");
  const stateObj = encodedState ? JSON.parse(atob(encodedState)) : null;
  const objectListFormik = location?.state?.objectListFormik
    ? location?.state?.objectListFormik
    : stateObj
    ? stateObj
    : "";
  const fromGlobalOpen = params.get("fromGlobalOpen");
  const fromLocation = location?.state?.fromLocation;
  const locationType = location?.state?.locationType;
  const floorPlanObjectId = location?.state?.floorPlanObjectId;

  const fromUsedObject = location?.state?.fromUsedObject;
  const fromCategory = location?.state?.fromCategory;
  const fromMaterial = location?.state?.fromMaterial;
  console.log(fromCategory, "fromCategory");

  const fromGlobal = location?.state?.fromGlobal
    ? location?.state?.fromGlobal
    : fromGlobalOpen
    ? fromGlobalOpen
    : "";

  const fromObjectTable = location?.state?.fromObjectTable
    ? location?.state?.fromObjectTable
    : "";
  // const isNavigatingRef = useRef(false);
  const fromPinOpen = params.get("fromPinOpen");
  const fromPin = location?.state?.fromPin
    ? location?.state?.fromPin
    : fromPinOpen
    ? fromPinOpen
    : "";
  const userData = JSON.parse(localStorage.getItem("user_info"));
  const userUsedLastScreen = userData?.last_used_screen;

  const [isOpen, setIsOpen] = React.useState(false);
  const { isSaving } = useSaving();

  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };
  const titleRowRef = useRef();
  const containerRowRef = useRef();
  const sessionRef = useRef(false);
  const sessionIdRef = useRef("");
  const isDetaillRef = useRef(false);
  const isChangedRef = useRef(false);
  const iSubmittedRef = useRef(false);
  const isAutosaveRef = useRef(false);
  const [descriptors, setDescriptors] = useState([]);
  const containerRef = useRef(null);
  const [showImageEnlarge, setShowEnlargeImage] = useState({
    parentIndex: "",
    childIndex: "",
    imageIndex: "",
    imageIdTitle: "",
    image: "",
    show: false,
    threeDpreview: "",
    title: "",
    isEdit: false,
    isExpand: false,
  });
  const [photographyStatus, setPhotographyStatus] = useState();
  const [activeKey, setActiveKey] = useState(null);
  const online = navigator.onLine;
  const routeParams = useParams();
  const id = fromList ? objectId : routeParams.id;

  const formik = useFormik({
    initialValues: {
      museum: userData.museum,
      images: [],
      reference_image: "",
      object_name: "",
      original_location: "",
      iconic_object: false,
      material: [],
      provenance: "",
      dateable_time_period: "",
      category: "",
      height: "",
      depth: "",
      width: "",
      dimensions: [],
      description: "",
      preliminary_condition_assessment: "",
      inscription_or_markers: "",
      function_or_usages: [],
      acquisition_method: "",
      tags: [],
      additional_notes: "",
      transit_location: "",
      selectedCategory: "",
      selectedMaterial: [],
      selectedTransit: "",
      selectedAcquistion: "",
      selectedOriginalLocation: "",
      conservation_grade: "",
      selectedConservation: "",
      selctedObject: [],
      preview_image: [],
      object_qr_code: [],
      period_end_date: "",
      period_start_date: "",
      period: "",
      accession_number: "",
      related_museum_object: "",
      drive_url: "",
      historical_description: "",
      cultural_significance: "",
      technique: "",
      references: "",
      number_of_missing_pieces: "",
      number_of_parts: "",
      assignValue: null,
      object_id: "",
      image_id: "",
      url: "",
      file: "",
      image_position: "",
      index: "",
      image_changed: false,
    },
    validate: (values) => {
      const errors = {};

      // Check if the last two elements of images array have prevImages key with values
      const lastImage = values.images[values.images.length - 1];

      const secondLastImage = values.images[values.images.length - 2];

      if (lastImage && lastImage.images === "") {
        errors.images = "The last image doesn't have any values in prevImages.";
      }

      if (secondLastImage && lastImage.images === "") {
        errors.images =
          "The second to last image doesn't have any values in prevImages.";
      }

      return errors;
    },
    onSubmit: async (values) => {
      iSubmittedRef.current = true;

      setIsAutoSave(false);

      if (isImage) {
        setIsImage(false);
      }

      await clearAutoSavedFromIndexedDB("digital");

      setButtonloader(true);

      const secondLastTwoImages = values.images.slice(-2); // This gives [third last, second last]

      // Check if both are filled
      const areSecondLastTwoImagesFilled = secondLastTwoImages.every(
        (image) => image.images !== ""
      );

      if (!areSecondLastTwoImagesFilled) {
        toast.error("Please upload the two images before the last one");
        setButtonloader(false);
        return; // Prevent submission
      }
      if (id) {
        values.id = id;
      }
      if (values.images) {
        // Now filter the trimmed array
        values.images = values.images.filter((image) => image.images !== "");
      }

      const newImageWithIndex = values.images?.map((liImage, liIndex) => ({
        ...liImage,
        index: liIndex,
        image_changed: liImage?.image_changed === true,
      }));

      if (values?.acquisition_method === "") {
        delete values?.acquisition_method;
      }
      values.images = newImageWithIndex;
      values.drive_url = folderUrl;
      delete values.tags;
      delete values.dimensions;
      delete values.function_or_usages;
      delete values.isDeleted;
      setSavedNextDigitalDataOverRide({ id: id, images: values?.images });
      if (online) {
        if (selectedGlbData.object_id) {
          createPhotography({
            id: id,
            images: values?.images,
            session: sessionIdRef.current,
          })((response) => {
            if (response?.status) {
              iSubmittedRef.current = true;
              sendSessionClose(
                "digital",
                sessionIdRef?.current,
                id,
                isChangedRef.current,
                userData?.museum
              );
              if (formik?.values?.assignValue) {
                assignUser(formik?.values?.assignValue)((response) => {
                  if (response?.status) {
                  }
                });
              }
              const formData = new FormData();

              formData.append("id", selectedGlbData.object_id);
              if (values?.file) {
                formData.append("file", values?.file);
              }
              if (values?.image_id) {
                formData.append("image_id", values?.image_id);
              }
              if (values?.url) {
                formData.append("url", values?.url);
              }
              formData.append("image_position", values?.image_position);
              formData.append("index", values?.index);
              formData.append("image_changed", values?.image_changed);

              createGlb(formData)((response) => {
                if (response?.status) {
                  setButtonloader(false);
                  toast.success(
                    id
                      ? "Object updated successfully!"
                      : "Object created successfully!"
                  );
                  if (fromList) {
                    onCloseObject();
                  } else if (fromLocation) {
                    if (locationType) {
                      navigate(
                        `/${
                          userData.museum_name
                            ? userData?.museum_name?.split(" ").join("_")
                            : "Nefos"
                        }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}?type=${locationType}`
                      );
                    } else {
                      navigate(
                        `/${
                          userData.museum_name
                            ? userData?.museum_name?.split(" ").join("_")
                            : "Nefos"
                        }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}`
                      );
                    }
                  } else {
                    fromGlobal
                      ? navigate(
                          `/${
                            userData.museum_name
                              ? userData?.museum_name?.split(" ").join("_")
                              : "Nefos"
                          }/${GLOBAL_SEARCH}`
                        )
                      : navigate(
                          `/${
                            userData.museum_name
                              ? userData?.museum_name?.split(" ").join("_")
                              : "Nefos"
                          }/${KANBAN_BOARD}`
                        );
                  }
                  setTempImage({
                    show: false,
                    data: [],
                  });
                } else {
                  setButtonloader(false);
                  toast.error("Something went wrong!");
                }
              });
            } else {
              setButtonloader(false);
              if (response?.status_code === 400 && response?.conflict) {
                setIsOverRide(true);
              }
              iSubmittedRef.current = false;
            }
          });
        } else {
          createPhotography({
            id: id,
            images: values?.images,
            session: sessionIdRef.current,
          })((response) => {
            if (response?.status) {
              iSubmittedRef.current = true;

              sendSessionClose(
                "digital",
                sessionIdRef?.current,
                id,
                isChangedRef.current,
                userData?.museum
              );
              if (formik?.values?.assignValue) {
                assignUser(formik?.values?.assignValue)((response) => {
                  if (response?.status) {
                    setButtonloader(false);

                    toast.success(
                      id
                        ? "Object updated successfully!"
                        : "Object created successfully!"
                    );
                    if (fromList) {
                      onCloseObject();
                    } else if (fromLocation) {
                      if (locationType) {
                        navigate(
                          `/${
                            userData.museum_name
                              ? userData?.museum_name?.split(" ").join("_")
                              : "Nefos"
                          }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}?type=${locationType}`
                        );
                      } else {
                        navigate(
                          `/${
                            userData.museum_name
                              ? userData?.museum_name?.split(" ").join("_")
                              : "Nefos"
                          }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}`
                        );
                      }
                    } else {
                      navigate(
                        `/${
                          userData.museum_name
                            ? userData?.museum_name?.split(" ").join("_")
                            : "Nefos"
                        }/${KANBAN_BOARD}`
                      );
                    }
                  }
                });
              } else {
                setButtonloader(false);

                toast.success(
                  id
                    ? "Object updated successfully!"
                    : "Object created successfully!"
                );
                if (fromList) {
                  onCloseObject();
                } else if (fromLocation) {
                  if (locationType) {
                    navigate(
                      `/${
                        userData.museum_name
                          ? userData?.museum_name?.split(" ").join("_")
                          : "Nefos"
                      }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}?type=${locationType}`
                    );
                  } else {
                    navigate(
                      `/${
                        userData.museum_name
                          ? userData?.museum_name?.split(" ").join("_")
                          : "Nefos"
                      }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}`
                    );
                  }
                } else {
                  navigate(
                    `/${
                      userData.museum_name
                        ? userData?.museum_name?.split(" ").join("_")
                        : "Nefos"
                    }/${KANBAN_BOARD}`
                  );
                }
              }
            } else {
              if (response?.status_code === 400 && response?.conflict) {
                setIsOverRide(true);
              }
              setButtonloader(false);
              iSubmittedRef.current = false;
            }
          });
        }
      } else {
        addItemToDB(values, "digital")
          .then(() => {
            setButtonloader(false);

            toast.success(
              id
                ? "Object updated successfully!"
                : "Object created successfully!"
            );
            formik.resetForm();
            navigate(
              `/${
                userData.museum_name
                  ? userData?.museum_name?.split(" ").join("_")
                  : "Nefos"
              }/${LIST_PHOTOGRAPHY}`
            );
          })
          .catch((error) => {
            setButtonloader(false);
            console.error("Failed to add item to IndexedDB:", error);
            toast.error("Failed to save data locally!");
          });
      }
    },
  });

  const { showPrompt, confirmNavigation, cancelNavigation } =
    useBeforeRouteChange(formik.values.isDeleted);

  const [isOpenhistory, setIsOpenhistory] = React.useState(false);
  const toggleDrawerhistory = () => {
    setIsOpenhistory((prevState) => !prevState);
  };

  const cancelDeleteHandler = useCallback(() => {
    cancelNavigation();
  }, [cancelNavigation]);

  const handleBack = async (type) => {
    // ✅ Block if already navigating
    // if (isNavigatingRef.current) {
    //   return;
    // }

    if (type === "discard") {
      formik?.setValues({
        ...formik?.values,
        isDeleted: false,
      });
      setIsAutoSave(false);
      await clearAutoSavedFromIndexedDB("digital");

      if (fromList) {
        onCloseObject();
      } else if (fromObjectTable) {
        navigate(
          `/${
            userData?.museum_name?.split(" ").join("_") || "Nefos"
          }/${LIST_PHOTOGRAPHY}`
        );
      } else if (fromLocation) {
        if (locationType) {
          navigate(
            `/${
              userData.museum_name
                ? userData?.museum_name?.split(" ").join("_")
                : "Nefos"
            }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}?type=${locationType}`
          );
        } else {
          navigate(
            `/${
              userData.museum_name
                ? userData?.museum_name?.split(" ").join("_")
                : "Nefos"
            }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}`
          );
        }
      } else if (fromCategory) {
        navigate(
          `/${
            userData?.museum_name?.split(" ").join("_") || "Nefos"
          }/${LIST_CATEGORY}`
        );
      } else if (fromMaterial) {
        navigate(
          `/${
            userData?.museum_name?.split(" ").join("_") || "Nefos"
          }/${LIST_MATERIAL}`
        );
      } else if (fromPin) {
        navigate(
          `/${
            userData?.museum_name?.split(" ").join("_") || "Nefos"
          }/${OBJECT_PIN}`
        );
      } else {
        navigate(
          `/${
            userData?.museum_name?.split(" ").join("_") || "Nefos"
          }/${KANBAN_BOARD}`
        );
      }
    } else {
      if (formik?.values.isDeleted) {
        const result = await Swal.fire({
          html: '<span style="font-size:20px;">Are you sure you want to leave this page? Any unsaved changes will be lost</span>',
          customClass: {
            container: "custom-alert-container",
            header: "custom-alert-header",
            title: "custom-alert-title",
            cancelButton: "alert-cancel",
            confirmButton: "alert-confirm",
          },
          showCloseButton: true,
          icon: "question",
          confirmButtonText: "Ok",
          confirmButtonColor: "#20409A",
          cancelButtonColor: "#fff",
          showCancelButton: true,
          iconColor: "#20409A",
        });

        if (result.isConfirmed) {
          // ✅ Set flag immediately
          // isNavigatingRef.current = true;

          // ✅ Reset isDeleted to prevent any beforeunload/route guard from triggering
          formik.setFieldValue("isDeleted", false, false);

          // ✅ Use setTimeout to ensure state update completes before navigation
          setTimeout(() => {
            if (fromNotification) {
              navigate(
                `/${
                  userData?.museum_name?.split(" ").join("_") || "Nefos"
                }/${lIST_NOTIFICATION}`
              );
            } else if (fromList) {
              onCloseObject();
            } else if (fromGlobal) {
              navigate(
                `/${
                  userData?.museum_name?.split(" ").join("_") || "Nefos"
                }/${GLOBAL_SEARCH}`
              );
            } else if (fromCategory) {
              navigate(
                `/${
                  userData?.museum_name?.split(" ").join("_") || "Nefos"
                }/${LIST_CATEGORY}`
              );
            } else if (fromLocation) {
              navigate(
                `/${
                  userData?.museum_name?.split(" ").join("_") || "Nefos"
                }/${LIST_LOCATION}`
              );
            } else if (fromMaterial) {
              navigate(
                `/${
                  userData?.museum_name?.split(" ").join("_") || "Nefos"
                }/${LIST_MATERIAL}`
              );
            } else if (fromObjectTable) {
              navigate(
                `/${
                  userData?.museum_name?.split(" ").join("_") || "Nefos"
                }/${LIST_PHOTOGRAPHY}`
              );
            } else if (fromPin) {
              navigate(
                `/${
                  userData?.museum_name?.split(" ").join("_") || "Nefos"
                }/${OBJECT_PIN}`
              );
            } else {
              navigate(
                `/${
                  userData?.museum_name?.split(" ").join("_") || "Nefos"
                }/${KANBAN_BOARD}`
              );
            }
          }, 0);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          cancelDeleteHandler();
        }
      } else {
        // Direct navigation without Swal
        if (fromNotification) {
          navigate(
            `/${
              userData?.museum_name?.split(" ").join("_") || "Nefos"
            }/${lIST_NOTIFICATION}`
          );
        } else if (fromList) {
          onCloseObject();
        } else if (fromGlobal) {
          navigate(
            `/${
              userData?.museum_name?.split(" ").join("_") || "Nefos"
            }/${GLOBAL_SEARCH}`
          );
        } else if (fromLocation) {
          navigate(
            `/${
              userData?.museum_name?.split(" ").join("_") || "Nefos"
            }/${LIST_LOCATION}`
          );
        } else if (fromCategory) {
          navigate(
            `/${
              userData?.museum_name?.split(" ").join("_") || "Nefos"
            }/${LIST_CATEGORY}`
          );
        } else if (fromMaterial) {
          navigate(
            `/${
              userData?.museum_name?.split(" ").join("_") || "Nefos"
            }/${LIST_MATERIAL}`
          );
        } else if (fromObjectTable) {
          navigate(
            `/${
              userData?.museum_name?.split(" ").join("_") || "Nefos"
            }/${LIST_PHOTOGRAPHY}`
          );
        } else if (fromPin) {
          navigate(
            `/${
              userData?.museum_name?.split(" ").join("_") || "Nefos"
            }/${OBJECT_PIN}`
          );
        } else {
          navigate(
            `/${
              userData?.museum_name?.split(" ").join("_") || "Nefos"
            }/${KANBAN_BOARD}`
          );
        }
      }
    }
  };

  useEffect(() => {
    if (online) {
      const syncDataWithServer = async () => {
        const pendingRequests = await getPendingRequests("digital");

        if (pendingRequests?.length > 0) {
          pendingRequests?.map((li) =>
            createPhotography({
              id: id,
              images: li?.images,
              session: sessionIdRef?.current,
            })((response) => {
              if (response?.status) {
                sendSessionClose(
                  "digital",
                  sessionIdRef?.current,
                  id,
                  isChangedRef.current,
                  userData?.museum
                );
                toast.success("Object succesfully uploaded!");
                if (formik?.values?.assignValue) {
                  assignUser(formik?.values?.assignValue)((response) => {
                    if (response?.status) {
                    }
                  });
                }
              }
            })
          );
        }
        // for (const request of pendingRequests) {
        //     try {
        //         const response = await createCategory({ values: request });
        //         if (response?.status) {
        //             console.log('Synced successfully:', request);
        //         } else {
        //             console.error('Failed to sync request:', request);
        //         }
        //     } catch (error) {
        //         console.error('Error syncing request:', error);
        //         // Exit the loop if an API call fails, and try again later.
        //         break;
        //     }
        // }

        // Clear pending requests if all were successful.
        await clearPendingRequests("digital");
      };

      syncDataWithServer();
    }
  }, []);

  // const handleSubmit = (event) => {

  // event.preventDefault();

  // const folderId = extractFolderId(folderUrl);
  // if (!folderId) {
  //     setError('Invalid Google Drive folder URL');
  //     return;
  // }

  // try {
  //     const response = await gapi.client.drive.files.list({
  //         q: `'${folderId}' in parents and mimeType contains 'image/' and trashed=false`,
  //         fields: 'files(id, name, mimeType, webViewLink, thumbnailLink, webContentLink)',
  //     });

  //     setFiles(response.result.files);
  //     setError('');
  // } catch (err) {

  //     setError(`Error: ${err?.message || 'Failed to fetch folder contents.'}`);
  // }
  // };

  //     try {
  //         await gapi.client.init({
  //             apiKey: process.env.REACT_APP_API_KEY,
  //             clientId: process.env.REACT_APP_CLIENT_IDS,
  //             scope: process.env.REACT_APP_SCOPES,
  //             discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'],
  //         });
  //     } catch (error) {
  //         setError('Error initializing the Google API client.');
  //     }
  // };

  // useEffect(() => {
  //     // Load the Google API client
  //     gapi.load('client:auth2', initializeGapiClient);
  // }, []);

  // // Extract folder ID from the Google Drive URL
  // const extractFolderId = (url) => {
  //     const regex = /\/folders\/([^?\/]+)/;
  //     const match = url.match(regex);
  //     return match ? match[1] : null;
  // };

  // // Handle form submission to fetch files
  // const handleSubmit = async (event) => {
  //     event.preventDefault();

  //     const folderId = extractFolderId(folderUrl);
  //     if (!folderId) {
  //         setError('Invalid Google Drive folder URL');
  //         return;
  //     }

  //     try {
  //         // Check if the user is signed in
  //         const GoogleAuth = gapi.auth2.getAuthInstance();
  //         const isSignedIn = GoogleAuth.isSignedIn.get();

  //         if (!isSignedIn) {
  //             // If not signed in, prompt user for sign-in
  //             await GoogleAuth.signIn({
  //                 prompt: 'consent', // Always ask for consent
  //                 redirect_uri: 'http://localhost:3000', // Update for your local server URL
  //             });
  //         }

  //         // Fetch files from the specified folder
  //         const response = await gapi.client.drive.files.list({
  //             q: `'${folderId}' in parents and mimeType contains 'image/'`,
  //             fields: 'files(id, name, mimeType, webViewLink, thumbnailLink, webContentLink)',
  //         });

  //         if (response.result.files && response.result.files.length > 0) {
  //             setFiles(response.result.files);
  //             setError('');
  //         } else {
  //             setError('No images found in the folder.');
  //         }
  //     } catch (err) {
  //         // Handle errors gracefully
  //         setError(`Error: ${err?.message || 'Failed to fetch folder contents.'}`);
  //     }
  // };

  useEffect(() => {
    const handleMouseMove = (event) => {
      const mouseX = event.clientX;
      const inRightSide = mouseX >= window.innerWidth * 0.8;

      setIsVisible(inRightSide);
    };

    document.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  const handleImageAddaHandler = () => {
    setIsAutoSave(true);
    const image = [...formik?.values?.images];

    if (image.length >= 8) {
      return;
    }

    image.unshift({
      images: "",
      image_position: `img${image.length + 1}`,
      index: "",
    });

    formik?.setValues({
      ...formik?.values,
      images: image,
    });
  };

  const imageDeleteHandler = (indexImage) => {
    setIsAutoSave(true);
    setDeletedImages(formik?.values?.images);
    const imageList = [...formik?.values?.images];

    const isImage = imageList[indexImage].images;

    if (imageList.length > 2 && indexImage < imageList.length - 2) {
      imageList.splice(indexImage, 1);
      formik.setValues({
        ...formik?.values,
        images: imageList,
        isDeleted: isImage ? true : false,
      });
    }
  };

  // const { getRootProps, getInputProps } = useDropzone({
  //     onDrop,
  //     accept: 'image/*',
  //     multiple: true,
  // });

  const handleModelError = () => {
    setError(true);
  };

  // useEffect(() => {
  //     createObject()

  // }, [])

  useEffect(() => {
    setLoading(true);
    if (id && !isSaving.digital) {
      getSingleObject({ id, is_photography_screen: true })((response) => {
        setFolderUrl(response?.data?.drive_url);

        const dataValue = response?.data;
        const material = dataValue?.material.map((li) => li.id);

        let imgarray = [];
        if (response?.data?.object_images.length > 0) {
          const containsGLB = response?.data?.object_images.some((image) =>
            image.images?.toLowerCase().includes(".glb")
          );

          imgarray = [
            ...response.data.object_images.map((image) => ({
              images: image.images,
              image_position: image.image_position,
              prevImages: image.thumbnail,
              index: image.index,
              image_changed: false,
              id: image.id,
            })),
          ];
        } else {
          imgarray = [
            {
              images: "",
              image_position: "Front",
              index: "",
              image_changed: false,
              prevImages: "",
            },
            {
              images: "",
              image_position: "Side",
              index: "",
              image_changed: false,
              prevImages: "",
            },
          ];
        }

        setDescriptors(response?.data?.descriptors);
        const materialName = response?.data?.material.map(
          (li) => li?.material_name
        );

        if (response?.status) {
          isDetaillRef.current = true;
          iSubmittedRef.current = false;
          setPhotographyStatus(response?.data?.photography_status);
          setSelectedUser({
            value: dataValue?.object_assigned,
            label: dataValue?.object_assigned_name,
          });

          gets3Image({
            page: 1,
            folder_name: response?.data?.accession_number,
            museum: userData?.museum,
            image_type: "digital_images",
          })((s3response) => {
            if (s3response?.status) {
              const firstNine = s3response?.data?.slice(0, 9) || [];

              const glbIndex = s3response?.data.findIndex((item) =>
                item?.s3_file?.toLowerCase().includes(".glb")
              );

              const glbItem =
                glbIndex !== -1 ? s3response?.data[glbIndex] : null;

              const imageItems = firstNine
                .filter(
                  (item) => !item?.s3_file?.toLowerCase().includes(".glb")
                )
                .slice(0, 8) // ensure max 8
                .map((newImage, index, array) => {
                  let image_position = "";
                  if (index === array.length - 2) image_position = "Front";
                  if (index === array.length - 1) image_position = "Side";

                  return {
                    images: newImage?.s3_file,
                    image_position,
                    index: "",
                    image_changed: true,
                    prevImages: newImage?.s3_file,
                  };
                });

              const newimgarray = [
                {
                  images: "",
                  image_position: "Front",
                  index: "",
                  image_changed: false,
                  prevImages: "",
                },
                {
                  images: "",
                  image_position: "Side",
                  index: "",
                  image_changed: false,
                  prevImages: "",
                },
              ];

              // Use imageItems if available, otherwise use imgarray
              const newFecthImage =
                imageItems.length > 0 ? imageItems : newimgarray;

              const anyHasId = imgarray.some((item) => item.id !== undefined);

              if (
                !dataValue?.object_images.length > 0 &&
                s3response?.data?.length > 0
              ) {
                setIsImage(true);
                localStorage.setItem("isImage", true);
              } else {
                setIsImage(false);
                localStorage.setItem("isImage", false);
              }

              if (!anyHasId && glbItem) {
                setSelectedGlbData({
                  object_id: id,
                  url: glbItem?.s3_file,
                  image_changed: true,
                  image_position: glbItem?.image_position,
                });
              }

              const imageWithoutGLB = imgarray?.filter(
                (item) => !item.images?.includes(".glb")
              );

              const mappedValues = {
                ...formik.values,
                url: glbItem ? glbItem?.s3_file : "",
                image_changed: true,
                object_pinned_id: dataValue?.object_pinned_id,
                is_pinned: dataValue?.is_pinned,
                category_code: dataValue?.category_code,
                prime_category_code: dataValue?.prime_category_code,
                object_label: dataValue?.object_label,
                prime_key_category: dataValue?.prime_key_category,
                object_name: dataValue?.object_name
                  ? dataValue?.object_name
                  : "",
                selectedPrimeCategory: dataValue?.prime_category_name,
                prime_category: dataValue?.prime_category,
                category: dataValue.category,
                selectedCategory: dataValue.category_name,
                material: material,
                selectedMaterial: materialName,
                preliminary_condition_assessment:
                  dataValue?.preliminary_condition_assessment,
                glb_image: dataValue.glb_image
                  ? dataValue?.glb_image
                  : glbItem && !anyHasId
                  ? glbItem?.s3_file
                  : "",
                images:
                  s3response?.data?.length > 0
                    ? anyHasId || dataValue.glb_image
                      ? imageWithoutGLB
                      : newFecthImage
                    : imageWithoutGLB,
                reference_image: dataValue?.reference_image
                  ? dataValue?.reference_image
                  : "",
                conservation_grade: dataValue?.conservation_grade
                  ? dataValue?.conservation_grade
                  : "",
                preview_image: dataValue?.object_images?.[0]?.images,
                selectedOriginalLocation:
                  dataValue?.original_location_room ||
                  dataValue?.original_location_storage_system ||
                  dataValue?.original_location_storage_unit
                    ? dataValue?.original_location_room ||
                      dataValue?.original_location_storage_system ||
                      dataValue?.original_location_storage_unit
                    : {},
                original_location_room: dataValue?.original_location_room?.id,
                original_location_storage_system:
                  dataValue?.original_location_storage_system?.id,
                original_location_storage_unit:
                  dataValue?.original_location_storage_unit?.id,
                provenance: dataValue?.provenance,
                acquisition_method: dataValue?.acquisition_method,
                selectedTransit:
                  dataValue?.transit_location_room ||
                  dataValue?.transit_location_storage_system ||
                  dataValue?.transit_location_storage_unit
                    ? dataValue?.transit_location_room ||
                      dataValue?.transit_location_storage_system ||
                      dataValue?.transit_location_storage_unit
                    : {},
                transit_location_room: dataValue?.transit_location_room?.id,
                transit_location_storage_system:
                  dataValue?.transit_location_storage_system?.id,
                transit_location_storage_unit:
                  dataValue?.transit_location_storage_unit?.id,
                description: dataValue?.description,
                inscription_or_markers: dataValue?.inscription_or_markers,
                additional_notes: dataValue?.additional_notes,
                tags: dataValue?.tags,
                function_or_usages: dataValue?.function_or_usages,
                object_qr_code: dataValue?.object_qr_code,
                depth: dataValue?.depth,
                width: dataValue?.width,
                height: dataValue?.height,
                period_end_date: dataValue?.period_end_date,
                period_start_date: dataValue?.period_start_date,
                period: dataValue?.period,
                accession_number: dataValue?.accession_number,
                transit_location:
                  dataValue?.transit_location_room ||
                  dataValue?.transit_location_storage_system ||
                  dataValue?.transit_location_storage_unit
                    ? dataValue?.transit_location_room?.code ||
                      dataValue?.transit_location_storage_system?.code ||
                      dataValue?.transit_location_storage_unit?.code
                    : "",
                iconic_object: dataValue?.iconic_object,
                dimensions: dataValue?.other_dimensions,
                historical_description: dataValue?.historical_description,
                technique: dataValue?.technique,
                references: dataValue?.references,
                cultural_significance: dataValue?.cultural_significance,
                related_museum_object: dataValue?.related_museum_object?.map(
                  (li) => li?.value
                ),
                selctedObject: dataValue?.related_museum_object,
                key_category: dataValue?.key_category,
                number_of_missing_pieces: dataValue?.number_of_missing_pieces,
                number_of_parts: dataValue?.number_of_parts,
                photography_description: dataValue?.photography_description,
                photo_setup_images: dataValue?.photo_setup_images,
                ledger_number: dataValue?.ledger_number,
                page_number: dataValue?.page_number,
                ledger_description: dataValue?.ledger_description,
                ledger_translation: dataValue?.ledger_translation,
                ledger_notes: dataValue?.ledger_notes,
                ledger_image: dataValue?.ledger_image,
                page_image: dataValue?.page_image,
                ledger_entry_images: dataValue?.ledger_entry_images,
                old_accession_number: dataValue?.old_accession_number,
              };
              formik.setValues(mappedValues);
              setSavedFormikData(structuredClone(mappedValues));

              setFiles(s3response?.data);
              setLoading(false);
            } else {
              const mappedValues = {
                ...formik.values,
                object_pinned_id: dataValue?.object_pinned_id,
                is_pinned: dataValue?.is_pinned,
                category_code: dataValue?.category_code,
                glb_image: response?.data?.glb_image,
                prime_category_code: dataValue?.prime_category_code,
                prime_key_category: dataValue?.prime_key_category,
                object_label: dataValue?.object_label,
                object_name: dataValue?.object_name
                  ? dataValue?.object_name
                  : "",
                selectedPrimeCategory: dataValue?.prime_category_name,
                prime_category: dataValue?.prime_category,
                category: dataValue.category,
                selectedCategory: dataValue.category_name,
                material: material,
                selectedMaterial: materialName,
                preliminary_condition_assessment:
                  dataValue?.preliminary_condition_assessment,
                images: imgarray,
                reference_image: dataValue?.reference_image
                  ? dataValue?.reference_image
                  : "",
                conservation_grade: dataValue?.conservation_grade
                  ? dataValue?.conservation_grade
                  : "",
                preview_image: dataValue?.object_images?.[0]?.images,
                selectedOriginalLocation:
                  dataValue?.original_location_room ||
                  dataValue?.original_location_storage_system ||
                  dataValue?.original_location_storage_unit
                    ? dataValue?.original_location_room ||
                      dataValue?.original_location_storage_system ||
                      dataValue?.original_location_storage_unit
                    : {},
                original_location_room: dataValue?.original_location_room?.id,
                original_location_storage_system:
                  dataValue?.original_location_storage_system?.id,
                original_location_storage_unit:
                  dataValue?.original_location_storage_unit?.id,
                provenance: dataValue?.provenance,
                acquisition_method: dataValue?.acquisition_method,
                selectedTransit:
                  dataValue?.transit_location_room ||
                  dataValue?.transit_location_storage_system ||
                  dataValue?.transit_location_storage_unit
                    ? dataValue?.transit_location_room ||
                      dataValue?.transit_location_storage_system ||
                      dataValue?.transit_location_storage_unit
                    : {},
                transit_location_room: dataValue?.transit_location_room?.id,
                transit_location_storage_system:
                  dataValue?.transit_location_storage_system?.id,
                transit_location_storage_unit:
                  dataValue?.transit_location_storage_unit?.id,
                description: dataValue?.description,
                inscription_or_markers: dataValue?.inscription_or_markers,
                additional_notes: dataValue?.additional_notes,
                tags: dataValue?.tags,
                function_or_usages: dataValue?.function_or_usages,
                object_qr_code: dataValue?.object_qr_code,
                depth: dataValue?.depth,
                width: dataValue?.width,
                height: dataValue?.height,
                period_end_date: dataValue?.period_end_date,
                period_start_date: dataValue?.period_start_date,
                period: dataValue?.period,
                accession_number: dataValue?.accession_number,
                transit_location:
                  dataValue?.transit_location_room ||
                  dataValue?.transit_location_storage_system ||
                  dataValue?.transit_location_storage_unit
                    ? dataValue?.transit_location_room?.code ||
                      dataValue?.transit_location_storage_system?.code ||
                      dataValue?.transit_location_storage_unit?.code
                    : "",
                iconic_object: dataValue?.iconic_object,
                dimensions: dataValue?.other_dimensions,
                historical_description: dataValue?.historical_description,
                technique: dataValue?.technique,
                references: dataValue?.references,
                cultural_significance: dataValue?.cultural_significance,
                related_museum_object: dataValue?.related_museum_object?.map(
                  (li) => li?.value
                ),
                selctedObject: dataValue?.related_museum_object,
                key_category: dataValue?.key_category,
                number_of_missing_pieces: dataValue?.number_of_missing_pieces,
                number_of_parts: dataValue?.number_of_parts,
                photography_description: dataValue?.photography_description,
                photo_setup_images: dataValue?.photo_setup_images,
                ledger_number: dataValue?.ledger_number,
                page_number: dataValue?.page_number,
                ledger_description: dataValue?.ledger_description,
                ledger_translation: dataValue?.ledger_translation,
                ledger_notes: dataValue?.ledger_notes,
                ledger_image: dataValue?.ledger_image,
                page_image: dataValue?.page_image,
                ledger_entry_images: dataValue?.ledger_entry_images,
                old_accession_number: dataValue?.old_accession_number,
              };
              formik.setValues(mappedValues);
              setSavedFormikData(structuredClone(mappedValues));
              setLoading(false);
            }
            const sessionOpenValues = {
              museum: userData?.museum,
              museum_object: id,
              screen: "photography",
              status: "open",
              is_changes_made: false,
            };

            createSession(sessionOpenValues)((response) => {
              if (response?.status_code === 200) {
                sessionIdRef.current = response?.data?.id;
                localStorage.setItem("digitalsession", response?.data?.id);
                sessionRef.current = true;
              }
            });
          });
        } else {
          setLoading(false);
        }
      });
    }
  }, [isSaving.digital, update, id]);

  const formikValues = formik?.values;

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, IndexOfImage) => {
    delete formik?.values?.file;
    let data =
      e.dataTransfer.getData("application/json") ||
      e.dataTransfer.getData("text/plain");

    setIsAutoSave(true);

    e.preventDefault();

    // Attempt to retrieve JSON or plain text data

    if (data) {
      const imageList = [...formik?.values?.images];
      const { thumbnailUrl, imageUrl } = JSON.parse(data);
      const isGLB = imageUrl.includes(".glb");
      const isGLBSlot =
        imageList[IndexOfImage]?.isThreed === true ||
        imageList[IndexOfImage]?.image_position === "glb";

      if (isGLBSlot && !isGLB) {
        toast.error("Only .glb files are allowed for this slot.");
        return;
      }

      if (!isGLBSlot && isGLB) {
        toast.error("GLB file not allowed for this image slot.");
        return;
      }
      const isGlb = imageUrl?.toLowerCase().includes(".glb"); // ✅ contains .glb anywhere

      imageList[IndexOfImage] = {
        ...imageList[IndexOfImage],
        images: imageUrl,
        image_changed: true,
        autosave: isImage === true ? true : false,
      };

      if (!isGlb) {
        imageList[IndexOfImage].prevImages = thumbnailUrl;
        formik?.setValues({
          ...formik?.values,
          images: imageList,
          isDeleted: false,
          filterAutosave: isImage === true ? true : false,
        });
      } else {
        setSelectedGlbData({
          object_id: id,
        });
        imageList[IndexOfImage].threeDpreview = "";
        imageList[IndexOfImage].prevImages = ""; // optional: clear if previously set
        imageList[IndexOfImage].image_position = "glb"; // optional: clear if previously set
        if (imageList[IndexOfImage]?.id) {
          formik?.setValues({
            ...formik?.values,
            image_id: imageList[IndexOfImage]?.id,
            object_id: id,
            url: imageUrl,
            image_position: "glb",
            image_changed: true,
            index: IndexOfImage,
            images: imageList,
            isDeleted: false,
          });
        } else {
          formik?.setValues({
            ...formik?.values,
            object_id: id,
            url: imageUrl,
            image_position: "glb",
            image_changed: true,
            index: IndexOfImage,
            images: imageList,
            isDeleted: false,
          });
        }
      }
    }
  };

  const handleGLBDrag = (e) => {
    setNoGlb(false);
    delete formik?.values?.file;
    let data =
      e.dataTransfer.getData("application/json") ||
      e.dataTransfer.getData("text/plain");
    setIsAutoSave(true);
    e.preventDefault();

    if (data) {
      const { thumbnailUrl, imageUrl } = JSON.parse(data);

      const isGLB = imageUrl.includes(".glb");
      if (!isGLB) {
        toast.error("Only .glb files are allowed for this slot.");
        return;
      }

      setSelectedGlbData({
        object_id: id,
      });

      formik?.setValues({
        ...formik?.values,
        object_id: id,
        url: imageUrl,
        tempUrl: imageUrl,
        image_position: "glb",
        image_changed: true,
        isDeleted: false,
        filterAutosave: isImage === true ? true : false,
      });
    }
  };

  useEffect(() => {
    const container = containerRef.current;

    if (!container) return;

    const handleDragOver = (event) => {
      const PRE_MARGIN_TRIGGER = 1000; // Trigger before visible margin
      const SCROLL_SPEED = 50;

      const { clientY } = event;
      const containerBounds = container.getBoundingClientRect();

      // Adjust bounds for pre-margin trigger
      const topTriggerZone = containerBounds.top - PRE_MARGIN_TRIGGER;
      const bottomTriggerZone = containerBounds.bottom + PRE_MARGIN_TRIGGER;

      // Scroll Up (before entering the top margin)
      if (clientY < topTriggerZone) {
        container.scrollTop -= SCROLL_SPEED;
      }

      // Scroll Down (before entering the bottom margin)
      if (clientY > bottomTriggerZone) {
        container.scrollTop += SCROLL_SPEED;
      }
    };

    container.addEventListener("dragover", handleDragOver);

    return () => {
      container.removeEventListener("dragover", handleDragOver);
    };
  }, [containerRef]);
  const handleClick = (indexImage) => {
    document.querySelector(`.reference-image-${indexImage}`).click();
  };

  const handleGlBClick = () => {
    document.querySelector(".glb-img").click();
  };

  const convertBase64 = (resume) => {
    return new Promise((resolve, reject) => {
      if (!(resume instanceof Blob)) {
        reject(new Error("Invalid parameter: Expected a Blob."));
        return;
      }
      const fileReader = new FileReader();
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
      fileReader.readAsDataURL(resume);
    });
  };

  const handleImageChange = async (indexImage, e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Only image files are allowed!");
      e.target.value = ""; // Reset invalid selection
      return;
    }
    const imageList = [...formik?.values?.images];
    const imageFile = e.target.files?.[0];

    delete formik?.values?.url;
    if (!imageFile) return;

    const fileName = imageFile.name.toLowerCase();
    const isGLB = fileName.includes(".glb");
    const isGLBSlot =
      imageList[indexImage]?.isThreed === true ||
      imageList[indexImage]?.image_position === "glb";

    // ✅ Validation based on actual file type

    if (!isGLBSlot && isGLB) {
      toast.error("GLB file not allowed for this image slot.");
      return;
    }

    setIsAutoSave(true);

    try {
      let base64 = await convertBase64(imageFile);

      // Normalize MIME for GLB files

      const updatedImage = {
        ...imageList[indexImage],
        images: base64,
        image_changed: true,
        autosave: isImage === true ? true : false,
      };

      updatedImage.prevImages = base64;

      setShowEnlargeImage((prev) => ({
        ...prev,
        image: base64,
      }));
      imageList[indexImage] = updatedImage;

      formik?.setValues({
        ...formik?.values,
        images: imageList,
        isDeleted: false,
        filterAutosave: isImage === true ? true : false,
      });

      // Reset input
      const fileInput = document.querySelector(
        `.reference-image-${indexImage}`
      );
      if (fileInput) {
        fileInput.type = "text";
        fileInput.value = "";
        fileInput.type = "file";
      }
    } catch (error) {
      console.error("Base64 conversion error:", error);
      toast.error("Failed to process the file.");
    }
  };

  const handleImageGLB = (e) => {
    setNoGlb(false);
    const imageFile = e.target.files?.[0];
    const fileName = imageFile.name.toLowerCase();
    const isGLB = fileName.includes(".glb");
    delete formik?.values?.url;
    setIsAutoSave(true);

    const tempUrl = URL.createObjectURL(imageFile);
    if (!isGLB) {
      toast.error("Only .glb files are allowed for this slot.");
      return;
    }

    setSelectedGlbData({ object_id: id });
    formik?.setValues({
      ...formik.values,
      object_id: id,
      file: imageFile,
      tempUrl: tempUrl,
      image_position: "glb",
      image_changed: true,
      isDeleted: false,
      filterAutosave: isImage === true ? true : false,
    });
    setShowEnlargeImage((prev) => ({ ...prev, show: false }));
  };

  const userChangeHandler = (value) => {
    setUser(defaultUser);
    setIsAutoSave(true);
    setSelectedUser(value);
    formik?.setValues({
      ...formik.values,
      assignValue: {
        id: id,
        object_assigned: value?.value,
      },
    });
  };
  const objectListFormikstate = fromGlobal
    ? {
        objectListFormik: objectListFormik,
        fromGlobal: true,
      }
    : fromPin
    ? {
        objectListFormik: objectListFormik,
        fromPin: true,
      }
    : fromCategory
    ? {
        objectListFormik: objectListFormik,
        fromUsedObject: true,
        fromCategory: true,
      }
    : fromMaterial
    ? {
        objectListFormik: objectListFormik,
        fromUsedObject: true,
        fromMaterial: true,
      }
    : fromLocation
    ? {
        objectListFormik: objectListFormik,
        fromLocation: true,
      }
    : {
        objectListFormik: objectListFormik,
      };

  const toggleLoader = (state, directionKey) => {
    setNextAndPreviousLoad({ [directionKey]: state });
  };

  // Common navigation function
  const goToNextOrPrev = (isNext) => {
    sendSessionClose(
      "digital",
      sessionIdRef?.current,
      id,
      isChangedRef.current,
      userData?.museum
    );
    navigate(
      `/${
        userData.museum_name
          ? userData.museum_name.split(" ").join("_")
          : "Nefos"
      }/${EDIT_PHOTOGRAPHY}/${isNext ? nextId : previousId}`,
      { state: objectListFormikstate }
    );
    formik?.resetForm();
    setUpdate((prev) => !prev);
    isChangedRef.current = false;
  };

  const handleObjectSubmitPhotography = async (type) => {
    iSubmittedRef.current = true;
    const isNext = type === "next";
    const directionKey = isNext ? "next" : "previous";

    // Common utility to toggle loaders

    // Start process
    toggleLoader(true, directionKey);
    setOverRideMove({ [directionKey]: true });
    setIsAutoSave(false);

    await clearAutoSavedFromIndexedDB("digital");

    const hasChanged = !deepEqual(formik.values, savedFormikData);
    if (formik?.values?.isDeleted) {
      formik?.setValues({ ...formik?.values, isDeleted: false });
    }

    if (!hasChanged) {
      isChangedRef.current = false;
      toggleLoader(false, directionKey);
      goToNextOrPrev(isNext);
      return;
    }

    const updateValues = { ...formik.values };

    // Clean up image data
    updateValues.images = (updateValues.images || []).filter(
      (img) => img.images !== ""
    );

    if (isImage && updateValues.filterAutosave) {
      updateValues.images = updateValues.images.filter((img) => img.autosave);
    }

    updateValues.images = updateValues.images.map((img, index) => ({
      ...img,
      index,
      image_changed: !!img.image_changed,
    }));

    if (!updateValues.acquisition_method)
      delete updateValues.acquisition_method;

    delete updateValues.tags;
    delete updateValues.dimensions;
    delete updateValues.function_or_usages;

    setSavedNextDigitalDataOverRide({ id, images: updateValues.images });

    // -----------------------------
    // ONLINE MODE
    // -----------------------------
    if (online) {
      const handleSuccess = () => {
        iSubmittedRef.current = true;
        setOverRideMove({ next: false, previous: false });
        setSavedNextDigitalDataOverRide();
        toggleLoader(false, directionKey);
        goToNextOrPrev(isNext);
      };

      const handleError = (response) => {
        if (response?.status_code === 400 && response?.conflict) {
          setIsOverRide(true);
        } else {
          toast.error("Something went wrong!");
        }
        iSubmittedRef.current = false;
        toggleLoader(false, directionKey);
      };

      const handleGlbUpload = (formValues) => {
        const formData = new FormData();
        if (id) formData.append("id", id);
        if (formValues?.file) formData.append("file", formValues.file);
        if (formValues?.image_id)
          formData.append("image_id", formValues.image_id);
        if (formValues?.url) formData.append("url", formValues.url);
        formData.append("image_position", formValues.image_position || 0);
        formData.append("index", formValues.index || 0);
        formData.append("image_changed", formValues.image_changed || false);

        createGlb(formData)((res) => {
          if (!res?.status) toast.error("Something went wrong!");
          setSelectedGlbData({ object_id: "" });
        });
      };

      const photographyPayload = {
        id,
        images: updateValues.images,
        session: sessionIdRef.current,
      };

      createPhotography(photographyPayload)((response) => {
        if (!response?.status) return handleError(response);
        if (updateValues.object_id) {
          handleGlbUpload(updateValues);
        }
        if (formik?.values?.assignValue) {
          assignUser(formik?.values?.assignValue)((assignRes) => {
            if (assignRes?.status) handleSuccess();
          });
        } else {
          handleSuccess();
        }
      });

      return;
    }

    // -----------------------------
    // OFFLINE MODE (IndexedDB)
    // -----------------------------
    addItemToDB(updateValues, "digital")
      .then(() => {
        toggleLoader(false, directionKey);
        goToNextOrPrev(isNext);
      })
      .catch((error) => {
        toggleLoader(false, directionKey);
        console.error("Failed to add item to IndexedDB:", error);
        toast.error("Failed to save data locally!");
      });
  };

  const pinChangeHandler = (e) => {
    formik?.setValues({
      ...formik?.values,
      is_pinned: formik?.values?.is_pinned ? false : true,
    });

    if (!formik?.values?.is_pinned) {
      addPinObject({ museum: userData?.museum, museum_object: id })(
        (pinnedResponse) => {
          if (pinnedResponse) {
          }
        }
      );
    } else {
      deletePinObject({ id: [id] })((response) => {
        if (response?.status) {
        }
      });
    }
  };

  const closehandler = () => {
    setIsOpenhistory(false);
    setIsOpen(false);
  };

  useEffect(() => {
    if (fromNotification) {
      setIsOpen(true);
      navigate(location.pathname, { replace: true, state: null });
    }
  }, [fromNotification]);

  useEffect(() => {
    if (isAutosave) {
      const savedFormik = formik?.values;

      if (id) savedFormik.id = id;
      savedFormik.drive_url = folderUrl;
      const newImageWithIndex = savedFormik.images?.map((liImage, liIndex) => ({
        ...liImage,
        index: liIndex,
      }));

      savedFormik.images = newImageWithIndex;

      autoSaveToIndexedDB("digital", savedFormik);
    }
  }, [formik, folderUrl]);

  let typingTimerUser;
  const userLoadOptionHandler = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerUser);
      typingTimerUser = setTimeout(() => {
        if (inputValue.length >= 1) {
          listUserDropdown({
            page: 1,
            museum_id: userData.museum,
            search: inputValue,
          })((response) => {
            if (response?.status) {
              setUser(response?.data);
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  useEffect(() => {
    listUserDropdown({ page: 1, museum_id: userData.museum })((response) => {
      if (response?.status) {
        setUser(response?.data);
        setDefaultUser(response?.data);
      }
    });
  }, []);

  useEffect(() => {
    if (newValue === "") {
      setUser(defaultUser);
    }
  }, [newValue, user]);

  const Notificationpop = ({
    isVisible,
    toggleDrawer,
    toggleDrawerhistory,
  }) => {
    return createPortal(
      <div
        className="notification"
        style={{
          zIndex: "999",
          display: isVisible ? "block" : "none",
          opacity: isVisible ? 1 : 0,
          visibility: isVisible ? "visible" : "hidden",
        }}
      >
        <Tooltip title="Discussions" placement="left">
          <div className="cmt-icon-query" onClick={toggleDrawer}>
            <TbMessageCircleCheck size={21} />
          </div>
        </Tooltip>
        <Tooltip title="History" placement="left">
          <div className="cmt-icon-history" onClick={toggleDrawerhistory}>
            <RiHistoryLine size={20} />
          </div>
        </Tooltip>
      </div>,
      document.body
    );
  };

  useEffect(() => {
    // Compare current form values with initialValues

    if (id) {
      if (isDetaillRef.current && isAutosave) {
        const hasChangedDetail = !deepEqual(formik?.values, savedFormikData);
        if (hasChangedDetail) {
          isChangedRef.current = true;
          localStorage.setItem("digitalchanges", true);
        }
      }
    }
  }, [formik.values]);

  const overRideCancel = (isClosed) => {
    setOverRideMove({
      next: false,
      previous: false,
    });
    setSavedNextDigitalDataOverRide();
    setIsOverRide(false);
    sessionRef.current = false;
    cancelSession({ id: sessionIdRef.current })((cancelResponse) => {
      if (cancelResponse?.status) {
        if (isClosed) {
          if (fromObjectTable) {
            navigate(
              `/${
                userData.museum_name
                  ? userData?.museum_name?.split(" ").join("_")
                  : "Nefos"
              }/${LIST_PHOTOGRAPHY}`
            );
          } else {
            navigate(
              `/${
                userData.museum_name
                  ? userData?.museum_name?.split(" ").join("_")
                  : "Nefos"
              }/${KANBAN_BOARD}`
            );
          }
        } else {
          setUpdate(!update);
        }
      }
    });
  };

  const overRideConfirmHandler = () => {
    setLoading(true);
    setIsOverRide(false);
    iSubmittedRef.current = true;

    const updateOverRideValue = {
      ...savedNextDigitalDataOverRide,
      is_override: true,
    };

    // ✅ Helper: builds the FormData for GLB upload
    const buildGlbFormData = (data) => {
      const formData = new FormData();

      if (id) formData.append("id", id);

      if (data?.file) {
        formData.append("file", data.file);
      } else if (data.glb_image || data?.url) {
        formData.append("url", data.glb_image || data.url);
      }

      if (data?.image_id) formData.append("image_id", data.image_id);
      formData.append("image_changed", !!data?.image_changed);

      // 🔍 LOG FORM DATA
      for (let [key, value] of formData.entries()) {
        console.log(key, value instanceof File ? value.name : value);
      }

      return formData;
    };

    // ✅ Helper: handles common navigation logic
    const commonNavigation = () => {
      if (fromList) return onCloseObject();

      const museumName = userData?.museum_name
        ? userData.museum_name.split(" ").join("_")
        : "Nefos";

      if (overRideMove?.next) {
        setOverRideMove({ next: false });
        navigate(`/${museumName}/${EDIT_PHOTOGRAPHY}/${nextId}`, {
          state: objectListFormikstate,
        });
      } else if (overRideMove?.previous) {
        setOverRideMove({ previous: false });
        navigate(`/${museumName}/${EDIT_PHOTOGRAPHY}/${previousId}`, {
          state: objectListFormikstate,
        });
      } else {
        navigate(`/${museumName}/${KANBAN_BOARD}`);
      }
    };

    // ✅ Helper: handles success flow
    const handleSuccess = (message) => {
      setLoading(false);
      setButtonloader(false);
      toast.success(message);
      commonNavigation();
      setTempImage({ show: false, data: [] });
    };

    // ✅ Helper: handles failure flow
    const handleError = () => {
      setLoading(false);
      setButtonloader(false);
      toast.error("Something went wrong!");
      iSubmittedRef.current = false;
    };

    // ✅ Main upload sequence
    const processGlbUpload = (data) => {
      const formData = buildGlbFormData(data);
      createGlb(formData)((res) => {});
    };

    const payload = {
      id,
      images: updateOverRideValue?.images,
      is_override: true,
      session: sessionIdRef?.current,
    };

    // ✅ Main createPhotography call
    createPhotography(payload)((response) => {
      if (!response?.status) return handleError();
      setOverRideMove({ next: false, previous: false });
      setSavedNextDigitalDataOverRide();
      processGlbUpload(formik?.values);
      // Assign user if needed
      if (formik?.values?.assignValue) {
        assignUser(formik.values.assignValue)((assignRes) => {
          if (assignRes?.status) {
          }
        });
      }
      handleSuccess(
        id ? "Object updated successfully!" : "Object created successfully!"
      );
    });
  };

  useEffect(() => {
    const markRefresh = () => {
      if (!iSubmittedRef.current) {
        sessionStorage.setItem("justRefreshed", "true");
      }
    };
    window.addEventListener("beforeunload", markRefresh);
    return () => {
      window.removeEventListener("beforeunload", markRefresh);
    };
  }, []);

  useEffect(() => {
    const handleBeforeUnload = () => {
      if (!iSubmittedRef.current && !isAutosaveRef.current) {
        sendSessionClose(
          "digital",
          sessionIdRef?.current,
          id,
          isChangedRef.current,
          userData?.museum,
          "isClosing"
        );
      }
    };
    window.addEventListener("unload", handleBeforeUnload);
    return () => window.removeEventListener("unload", handleBeforeUnload);
  }, []);

  useEffect(() => {
    return () => {
      if (!iSubmittedRef.current && !isAutosaveRef.current) {
        sendSessionClose(
          "digital",
          sessionIdRef?.current,
          id,
          isChangedRef.current,
          userData?.museum,
          "isClosing"
        );
      }
    };
  }, [location.pathname]);
  useEffect(() => {
    setNextId(null);
    setPreviousId(null);

    if (id) {
      const objectListdata = {
        ...objectListFormik,
        current_object: id,
        screen: fromPin ? "pinned_objects" : "photography",
        is_global_search: fromGlobal ? true : false,
      };

      if (fromUsedObject || fromLocation) {
        delete objectListdata.screen;
        delete objectListdata.is_global_search;
      }

      nextAndPreviousHandler(objectListdata)((response) => {
        if (response?.status) {
          if (response?.data?.next_object) {
            setNextId(response?.data?.next_object);
          }
          if (response?.data?.previous_object) {
            setPreviousId(response?.data?.previous_object);
          }
        }
      });
    }
  }, [id]);

  useEffect(() => {
    if (!fromList) {
      const values = {
        museum: userData?.museum,
        screen: "Photography",
      };
      if (userUsedLastScreen !== "Photography") {
        usedLastScreen(values)((response) => {
          localStorage.setItem(
            "user_info",
            JSON.stringify({ ...userData, last_used_screen: "Photography" })
          );
        });
      }
    }
  }, []);

  useEffect(() => {
    isAutosaveRef.current = isAutosave;
  }, [isAutosave]);

  return (
    <>
      <section
        style={{ paddingTop: "60px" }}
        className="dashboard asset-management light-wrapper dark-wrapper"
      >
        <Modal
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="category-view-modal s3-modal"
          show={s3modal.show}
          onHide={() => setS3modal({ show: false })}
        >
          <Modal.Header className="detail-view-header" closeButton>
            <Modal.Title>Sync with cloud</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                height: "150px",
              }}
            >
              <Fileurl
                update={update}
                setUpdate={setUpdate}
                detail={true}
                accession_number={formik?.values?.accession_number}
                setS3modal={setS3modal}
              />
            </div>
          </Modal.Body>
        </Modal>
        {showImageEnlarge?.show && (
          <ImageEnlarge
            setShowReference={setShowEnlargeImage}
            imageData={showImageEnlarge}
          />
        )}
        <div className="add-building-container">
          {fromList ? (
            <Notificationpop
              isVisible={isVisible}
              toggleDrawer={toggleDrawer}
              toggleDrawerhistory={toggleDrawerhistory}
            />
          ) : (
            <div
              className="notification"
              style={{
                display: isVisible ? "block" : "none",
                opacity: isVisible ? 1 : 0,
                visibility: isVisible ? "visible" : "hidden",
              }}
            >
              <Tooltip
                title="Discussion"
                placement="left"
                sx={{
                  backgroundColor: "#E2F1FF ",
                }}
              >
                <div className="cmt-icon-query" onClick={toggleDrawer}>
                  <TbMessageCircleCheck size={21} />
                </div>
              </Tooltip>
              <Tooltip title="History" placement="left">
                <div className="cmt-icon-history" onClick={toggleDrawerhistory}>
                  <RiHistoryLine size={20} />
                </div>
              </Tooltip>
            </div>
          )}
          <Container ref={containerRowRef}>
            {loading ||
            nextAndPreviousLoad.next ||
            nextAndPreviousLoad.previous ? (
              <Loader />
            ) : (
              <Form
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                onSubmit={formik.handleSubmit}
              >
                {buttonloader && <div className="overlay-cover" />}
                <div
                  onClick={closehandler}
                  ref={titleRowRef}
                  className="add-category-title-row"
                  style={{
                    flexDirection: "column",
                    position: "sticky",
                    zIndex: "2",
                    backgroundColor: "white",
                    top: fromList ? "0px" : "61px",
                    paddingTop: "20px",
                    boxShadow: "rgba(0, 0, 0, 0.45) 0px 25px 20px -34px",
                    marginLeft: "-11px",
                  }}
                >
                  <div
                    className=" title-row-content"
                    style={{ justifyContent: "space-between" }}
                  >
                    <div style={{ display: "flex", gap: "9px" }}>
                      <div className="title-icon " onClick={handleBack}>
                        <GoArrowLeft />
                      </div>
                      <div className=" titles">
                        <p>Back to Object list</p>
                        <h4>Add photography</h4>
                      </div>
                    </div>
                    <div className="submit-btn-row">
                      {id && !fromList && (
                        <Tooltip
                          title={previousId ? "" : "No previous object"}
                          placement="top-start"
                        >
                          <Button
                            disabled={!previousId}
                            style={{
                              cursor: previousId ? "pointer" : "not-allowed",
                              pointerEvents: "auto",
                              paddingBottom: "6px",
                              paddingTop: "6px",
                            }}
                            onClick={() =>
                              handleObjectSubmitPhotography("previous")
                            }
                            className={
                              nextAndPreviousLoad?.previous
                                ? "submit-btn"
                                : "discard-btn"
                            }
                            type="button"
                          >
                            {nextAndPreviousLoad?.previous ? (
                              <SimpleBackdrop />
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "7px",
                                }}
                              >
                                <GrLinkPrevious style={{ fontSize: "18px" }} />
                                <p> Previous object</p>
                              </div>
                            )}
                          </Button>
                        </Tooltip>
                      )}
                      {id && !fromList && (
                        <Tooltip
                          title={nextId ? "" : "No next object"}
                          placement="top-end"
                        >
                          <Button
                            disabled={!nextId}
                            style={{
                              cursor: nextId ? "pointer" : "not-allowed",
                              pointerEvents: "auto",
                              paddingBottom: "6px",
                              paddingTop: "6px",
                            }}
                            onClick={() =>
                              handleObjectSubmitPhotography("next")
                            }
                            className={
                              nextAndPreviousLoad?.next
                                ? "submit-btn"
                                : "discard-btn"
                            }
                            type="button"
                          >
                            {nextAndPreviousLoad?.next ? (
                              <SimpleBackdrop />
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "7px",
                                }}
                              >
                                <p> Next object</p>
                                <GrLinkNext style={{ fontSize: "18px" }} />
                              </div>
                            )}
                          </Button>
                        </Tooltip>
                      )}
                    </div>
                  </div>
                  <Row
                    style={{
                      marginTop: "38px",
                      backgroundColor: "#eff6ff",
                      paddingTop: "13px",
                      paddingBottom: "9px",
                    }}
                  >
                    <Col
                      style={{
                        paddingLeft: "15px",
                        display: "flex",
                        gap: "10px",
                      }}
                      lg={5}
                    >
                      <Form.Label>Object name</Form.Label>

                      <h5
                        style={{ fontWeight: "bold", wordBreak: "break-word" }}
                      >
                        {formik?.values?.object_name}
                      </h5>
                    </Col>
                    <Col lg={4}>
                      <Form.Group
                        style={{
                          display: "flex",
                          gap: "5px",
                          paddingBottom: "1px",
                        }}
                        className="left-input-field"
                      >
                        <Form.Label style={{ width: "44%" }}>
                          Assign user
                        </Form.Label>
                        <AsyncSelect
                          loadOptions={userLoadOptionHandler}
                          defaultOptions={user}
                          value={selectedUser}
                          type="text"
                          placeholder="Select"
                          onChange={userChangeHandler}
                          className="assign-user-async"
                          onInputChange={(newValue, { action }) => {
                            setNewValue(newValue);
                            if (action === "input-change" && newValue === "") {
                              setUser(defaultUser); // Reset to default options
                            }
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <div
                      style={{
                        position: "absolute",
                        width: "fit-content",
                        right: "0",
                        bottom: "22px",
                      }}
                    >
                      <div style={{ display: "flex", gap: "9px" }}>
                        <Tooltip
                          title={
                            formik?.values?.is_pinned
                              ? "Unpin object"
                              : "Pin object"
                          }
                        >
                          <div
                            className={
                              formik?.values?.is_pinned
                                ? "objectpin-container"
                                : "object-unpin-container"
                            }
                            onClick={pinChangeHandler}
                          >
                            <LuPin />
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                  </Row>
                </div>

                <div onClick={closehandler} className="add-object-field-box">
                  <Row className="primary-field-row">
                    <div className="add-object">
                      <div
                        className="feature-full-div"
                        style={{ paddingBottom: "20px" }}
                      >
                        <div className="col-lg-7 feature-left">
                          <ul className="field-ul">
                            <li className="field-li row">
                              <div className="col-md-3">Primary category</div>
                              <div
                                className="col-md-7"
                                style={{
                                  display: "flex",
                                  gap: "11px",
                                  alignItems: "center",
                                }}
                              >
                                {formikValues?.selectedPrimeCategory &&
                                  formikValues.selectedPrimeCategory
                                    .charAt(0)
                                    .toUpperCase() +
                                    formikValues.selectedPrimeCategory
                                      .slice(1)
                                      .toLowerCase()}
                                {formikValues?.prime_category_code && (
                                  <p
                                    style={{ color: "gray" }}
                                  >{`(${formikValues?.prime_category_code})`}</p>
                                )}
                                {formikValues?.prime_key_category ===
                                  "True" && (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <img
                                      style={{ height: "18px" }}
                                      alt="star"
                                      src={star}
                                    />
                                  </div>
                                )}
                              </div>
                            </li>
                            <li className="field-li row">
                              <div className="col-md-3">Subcategory</div>
                              <div
                                className="col-md-7"
                                style={{
                                  display: "flex",
                                  gap: "11px",
                                  alignItems: "center",
                                }}
                              >
                                {formikValues?.selectedCategory &&
                                  formikValues.selectedCategory
                                    .charAt(0)
                                    .toUpperCase() +
                                    formikValues.selectedCategory
                                      .slice(1)
                                      .toLowerCase()}
                                {formikValues?.category_code && (
                                  <p
                                    style={{ color: "gray" }}
                                  >{`(${formikValues?.category_code})`}</p>
                                )}
                                {formikValues?.key_category === "True" && (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <img
                                      style={{ height: "18px" }}
                                      alt="star"
                                      src={star}
                                    />
                                  </div>
                                )}
                              </div>
                            </li>
                            <li className="field-li row">
                              <div className="col-md-3">Object label</div>
                              <div
                                className="col-md-7"
                                style={{
                                  display: "flex",
                                  gap: "11px",
                                  alignItems: "center",
                                }}
                              >
                                {formikValues?.object_label
                                  ? formikValues?.object_label
                                  : ""}
                              </div>
                            </li>
                            <li className="field-li row">
                              <div
                                className="col-md-3"
                                style={{ overflowWrap: "break-word" }}
                              >
                                Number of parts
                              </div>
                              <div className="col-md-7">
                                <p>{formikValues?.number_of_parts}</p>
                              </div>
                            </li>
                            <li className="field-li row">
                              <div
                                className="col-md-3"
                                style={{ overflowWrap: "break-word" }}
                              >
                                Number of missing pieces
                              </div>
                              <div className="col-md-7">
                                <p>{formikValues?.number_of_missing_pieces}</p>
                              </div>
                            </li>
                            <li className="field-li row">
                              <div className="col-md-3">Materials</div>
                              <div className="col-md-7">
                                <div className="material_tags">
                                  {formikValues?.selectedMaterial.map(
                                    (iteam, index) => (
                                      <p key={index} className="p_tag">
                                        {iteam}
                                      </p>
                                    )
                                  )}
                                </div>
                              </div>
                            </li>
                            <li className="field-li row">
                              <div className="col-md-3">
                                <p>Dimensions(cm)</p>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "20px",
                                  flexWrap: "wrap",
                                }}
                                className="col-md-7"
                              >
                                <div style={{ display: "flex" }}>
                                  Height-<p>{formikValues?.height}</p>
                                </div>
                                <div style={{ display: "flex" }}>
                                  Width-<p>{formikValues?.width}</p>
                                </div>
                                <div style={{ display: "flex" }}>
                                  Depth-<p>{formikValues?.depth}</p>
                                </div>
                                {formikValues?.dimensions?.map((li) => (
                                  <div style={{ display: "flex" }}>
                                    {`${li?.dimension_name}-`}
                                    <p>{li?.dimension_value}</p>
                                  </div>
                                ))}
                              </div>
                            </li>
                            {descriptors?.length > 0 && (
                              <li className="field-li row">
                                <div className="col-md-3">
                                  <p>Category descriptors</p>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "20px",
                                    flexWrap: "wrap",
                                  }}
                                  className="col-md-7"
                                >
                                  {descriptors?.map((li) => {
                                    let multiDEscr = [];
                                    if (
                                      li?.attribute_type === "Multiple dropdown"
                                    ) {
                                      try {
                                        multiDEscr = li?.description
                                          ? JSON.parse(li.description)
                                          : [];
                                      } catch (e) {
                                        console.error(
                                          "Failed to parse JSON for description:",
                                          li.description
                                        );
                                        multiDEscr = [li.description]; // fallback to single string in array
                                      }
                                    }
                                    return (
                                      <div style={{ display: "flex" }}>{`${
                                        li?.attribute_name
                                          ? li?.attribute_name
                                              .charAt(0)
                                              .toUpperCase() +
                                            li?.attribute_name.slice(1)
                                          : ""
                                      }-${
                                        li?.attribute_type ===
                                        "Multiple dropdown"
                                          ? multiDEscr?.map((li) => ` ${li}`)
                                          : li?.description
                                      } `}</div>
                                    );
                                  })}
                                </div>
                              </li>
                            )}
                            <li className="field-li row">
                              <div className="col-md-3">Original location</div>
                              {formikValues?.selectedOriginalLocation?.code && (
                                <div className="col-md-7">
                                  {`${
                                    formikValues?.selectedOriginalLocation
                                      ?.storage_unit ||
                                    formikValues?.selectedOriginalLocation
                                      ?.storage_system_name ||
                                    formikValues?.selectedOriginalLocation
                                      ?.room_number
                                  }`}
                                  <span
                                    style={{
                                      color: "gray",
                                      marginLeft: "9px",
                                      fontSize: "16px",
                                    }}
                                  >{`(${formikValues?.selectedOriginalLocation?.code})`}</span>
                                </div>
                              )}
                            </li>

                            <li className="field-li row">
                              <div className="col-md-3"> Transit location</div>
                              {formikValues?.selectedTransit?.code && (
                                <div className="col-md-7">
                                  {" "}
                                  {`${
                                    formikValues?.selectedTransit
                                      ?.storage_unit ||
                                    formikValues?.selectedTransit
                                      ?.storage_system_name ||
                                    formikValues?.selectedTransit?.room_number
                                  }`}
                                  <span
                                    style={{
                                      color: "gray",
                                      marginLeft: "9px",
                                      fontSize: "16px",
                                    }}
                                  >{`(${formikValues?.selectedTransit?.code})`}</span>
                                </div>
                              )}
                            </li>
                          </ul>
                        </div>

                        <div className="col-lg-4 feature-right">
                          <div className="img-main-div">
                            <div
                              className="img-div"
                              onClick={() =>
                                setShowEnlargeImage({
                                  show: true,
                                  title: "Reference image",
                                  image: formikValues?.reference_image,
                                  isEdit: false,
                                })
                              }
                              style={{ cursor: "pointer" }}
                            >
                              {formikValues?.iconic_object && (
                                <div className="iconic_photography">
                                  <RiVipCrownFill color="gold" />
                                </div>
                              )}
                              {formikValues?.reference_image ? (
                                <img
                                  height={"100%"}
                                  width={"100%"}
                                  style={{ objectFit: "contain" }}
                                  src={formikValues?.reference_image}
                                  alt="referenec-image"
                                />
                              ) : (
                                <img
                                  className="image"
                                  src={notFound}
                                  alt="error-image"
                                />
                              )}
                            </div>
                            <div
                              style={{
                                height: "20%",
                                width: "100%",
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <p>{formikValues?.accession_number}</p>
                            </div>
                          </div>
                          <div className="qr-code-main-div">
                            <div className="qr-code-div">
                              <img
                                className="qr-code-"
                                src={formikValues?.object_qr_code}
                                alt="QR code"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <Accordion
                        color="blue"
                        activeKey={activeKey}
                        onSelect={(selectedKey) => setActiveKey(selectedKey)}
                      >
                        <Accordion.Item eventKey="0">
                          <Accordion.Header
                            style={{
                              borderBottom: "1px solid lightgray",
                              zIndex: 0,
                              position: "relative",
                            }}
                            bsPrefix="object-accordion-header"
                          >
                            <h6
                              style={{ fontWeight: "600", marginLeft: "-20px" }}
                            >
                              Object details
                            </h6>
                          </Accordion.Header>
                          <Accordion.Body className="accordian_body_digital">
                            <div style={{ marginTop: "30px" }}>
                              <ul className="field-ul">
                                <li className="field-li row">
                                  <div className="col-md-2">
                                    Dateable time period
                                  </div>
                                  <div className="dateable-time-div col-md-8">
                                    <div className="dateable-input-select-div">
                                      <p>{formikValues?.period}</p>
                                    </div>
                                    <div className="dateable-input-select-div">
                                      <p>{formikValues?.period_start_date}</p>
                                    </div>{" "}
                                    -
                                    <div className="dateable-input-select-div">
                                      <p>{formikValues?.period_end_date}</p>
                                    </div>
                                  </div>
                                </li>
                                <li className="field-li row">
                                  <div className="col-md-2">Provenance</div>
                                  <div className="col-md-8">
                                    {formikValues?.provenance &&
                                      formikValues.provenance
                                        .charAt(0)
                                        .toUpperCase() +
                                        formikValues.provenance
                                          .slice(1)
                                          .toLowerCase()}
                                  </div>
                                </li>
                                <li className="field-li row">
                                  <div className="col-md-2">
                                    Acquisition method
                                  </div>
                                  <div className="col-md-8">
                                    {formikValues?.acquisition_method}
                                  </div>
                                </li>
                                <li className="field-li row">
                                  <div className="col-md-2">
                                    Preliminary assessment{" "}
                                  </div>
                                  <div className="col-md-8">
                                    {formikValues?.preliminary_condition_assessment &&
                                      formikValues.preliminary_condition_assessment
                                        .charAt(0)
                                        .toUpperCase() +
                                        formikValues.preliminary_condition_assessment
                                          .slice(1)
                                          .toLowerCase()}
                                  </div>
                                </li>
                                <li className="field-li row ">
                                  <div className="col-md-2">Tags</div>
                                  <div className="col-md-8">
                                    <div className="tags">
                                      {formikValues?.tags?.map(
                                        (iteam, index) => (
                                          <p key={index} className="p_tag">
                                            {iteam?.tag_name}
                                          </p>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </li>
                                {/* <li className='field-li row' >
                                                                    <div className='col-md-2'>Detailed description</div>
                                                                    <div className='col-md-8'>
                                                                        <p>{formikValues?.description}</p>
                                                                    </div>
                                                                </li> */}
                                <li className="field-li row">
                                  <div className="col-md-2">Related object</div>
                                  <div className="col-md-8">
                                    <div className="tags">
                                      {formikValues?.selctedObject?.map(
                                        (li) => (
                                          <p className="p_tag">
                                            {li?.label &&
                                              li?.label
                                                ?.charAt(0)
                                                .toUpperCase() +
                                                li?.label
                                                  ?.slice(1)
                                                  .toLowerCase()}
                                          </p>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </li>
                                <li className="field-li row ">
                                  <div className="col-md-2">
                                    Function or usage
                                  </div>
                                  <div className="col-md-8">
                                    <div className="tags">
                                      {formikValues?.function_or_usages?.map(
                                        (iteam, index) => (
                                          <p key={index} className="p_tag">
                                            {iteam?.function_or_usage}
                                          </p>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </li>
                                <li className="field-li row">
                                  <div className="col-md-2">
                                    Inscriptions or markers
                                  </div>
                                  <div className="col-md-8">
                                    <p>
                                      {formikValues?.inscription_or_markers}
                                    </p>
                                  </div>
                                </li>
                                <li className="field-li row">
                                  <div className="col-md-2">
                                    {" "}
                                    Additional notes
                                  </div>
                                  <div className="col-md-8">
                                    <p>{formikValues?.additional_notes}</p>
                                  </div>
                                </li>
                                <li className="field-li row">
                                  <div className="col-md-2">
                                    Historical description
                                  </div>
                                  <div className="col-md-10">
                                    <p>
                                      {formikValues?.historical_description}
                                    </p>
                                  </div>
                                </li>
                                <li className="field-li row">
                                  <div className="col-md-2">Technique</div>
                                  <div className="col-md-10">
                                    <p>{formikValues?.technique}</p>
                                  </div>
                                </li>
                                <li className="field-li row">
                                  <div className="col-md-2">
                                    Cultural significance
                                  </div>
                                  <div className="col-md-10">
                                    <p>{formikValues?.cultural_significance}</p>
                                  </div>
                                </li>
                                <li className="field-li row">
                                  <div
                                    className="col-md-2"
                                    style={{ overflowWrap: "break-word" }}
                                  >
                                    {" "}
                                    References / Bibliography
                                  </div>
                                  <div className="col-md-10">
                                    <p>{formikValues?.references}</p>
                                  </div>
                                </li>

                                <li className="field-li row">
                                  <div
                                    className="col-md-2"
                                    style={{ overflowWrap: "break-word" }}
                                  >
                                    Ledger number
                                  </div>
                                  <div className="col-md-10">
                                    <p>{formikValues?.ledger_number}</p>
                                  </div>
                                </li>
                                <li className="field-li row">
                                  <div
                                    className="col-md-2"
                                    style={{ overflowWrap: "break-word" }}
                                  >
                                    Ledger image
                                  </div>
                                  <div className="col-md-10">
                                    {formikValues?.ledger_image && (
                                      <div
                                        style={{
                                          height: "100px",
                                          width: "100px",
                                          borderRadius: "10px",
                                          border:
                                            "1px solid rgb(238, 238, 238)",
                                          padding: "5px",
                                        }}
                                      >
                                        <img
                                          alt="ledeger-image"
                                          onClick={() => {
                                            setShowEnlargeImage({
                                              show: true,
                                              image: formikValues?.ledger_image,
                                              isEdit: false,
                                              title: "Ledger image",
                                            });
                                          }}
                                          src={formikValues?.ledger_image}
                                          style={{
                                            height: "100%",
                                            width: "100%",
                                            objectFit: "contain",
                                          }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </li>
                                <li className="field-li row">
                                  <div
                                    className="col-md-2"
                                    style={{ overflowWrap: "break-word" }}
                                  >
                                    Page number
                                  </div>
                                  <div className="col-md-10">
                                    <p>{formikValues?.page_number}</p>
                                  </div>
                                </li>
                                <li className="field-li row">
                                  <div
                                    className="col-md-2"
                                    style={{ overflowWrap: "break-word" }}
                                  >
                                    Old accession number
                                  </div>
                                  <div className="col-md-10">
                                    <p>{formikValues?.old_accession_number}</p>
                                  </div>
                                </li>
                                <li className="field-li row">
                                  <div
                                    className="col-md-2"
                                    style={{ overflowWrap: "break-word" }}
                                  >
                                    Page image
                                  </div>
                                  <div className="col-md-10">
                                    {formikValues?.page_image && (
                                      <div
                                        style={{
                                          height: "100px",
                                          width: "100px",
                                          borderRadius: "10px",
                                          border:
                                            "1px solid rgb(238, 238, 238)",
                                          padding: "5px",
                                        }}
                                      >
                                        <img
                                          alt="page-image"
                                          onClick={() => {
                                            setShowEnlargeImage({
                                              show: true,
                                              image: formikValues?.page_image,
                                              isEdit: false,
                                              title: "Page image",
                                            });
                                          }}
                                          src={formikValues?.page_image}
                                          style={{
                                            height: "100%",
                                            width: "100%",
                                            objectFit: "contain",
                                          }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </li>
                                <li className="field-li row">
                                  <div
                                    className="col-md-2"
                                    style={{ overflowWrap: "break-word" }}
                                  >
                                    Ledger entry description
                                  </div>
                                  <div className="col-md-10">
                                    <p>{formikValues?.ledger_description}</p>
                                  </div>
                                </li>
                                <li className="field-li row">
                                  <div
                                    className="col-md-2"
                                    style={{ overflowWrap: "break-word" }}
                                  >
                                    Ledger entry translation
                                  </div>
                                  <div className="col-md-10">
                                    <p>{formikValues?.ledger_translation}</p>
                                  </div>
                                </li>
                                <li className="field-li row">
                                  <div
                                    className="col-md-2"
                                    style={{ overflowWrap: "break-word" }}
                                  >
                                    Ledger notes
                                  </div>
                                  <div className="col-md-10">
                                    <p>{formikValues?.ledger_notes}</p>
                                  </div>
                                </li>

                                <li className="field-li row">
                                  <div
                                    className="col-md-2"
                                    style={{ overflowWrap: "break-word" }}
                                  >
                                    Ledger entry images
                                  </div>
                                  <div
                                    className="col-md-10"
                                    style={{
                                      display: "flex",
                                      gap: "10px",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    {formikValues?.ledger_entry_images?.map(
                                      (liEntry) => (
                                        <div
                                          style={{
                                            height: "100px",
                                            width: "100px",
                                            borderRadius: "10px",
                                            border: "1px solid #EEEEEE",
                                            padding: "5px",
                                          }}
                                        >
                                          <img
                                            alt="ledger-entry"
                                            style={{
                                              height: "100%",
                                              width: "100%",
                                              objectFit: "contain",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              const reorderedImages = [
                                                liEntry,
                                                ...formikValues?.ledger_entry_images.filter(
                                                  (img) =>
                                                    img.entry_image !==
                                                    liEntry.entry_image
                                                ),
                                              ];
                                              setShowEnlargeImage({
                                                show: true,
                                                image: reorderedImages,
                                                isEdit: false,
                                                title: "Entry image",
                                              });
                                            }}
                                            src={liEntry?.entry_image}
                                          />
                                        </div>
                                      )
                                    )}
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>

                      <div className="form-body">
                        <div className="label-div">
                          <h5 style={{ fontWeight: "bold" }}>
                            Detailed photography
                          </h5>

                          <form
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "50%",
                              height: "100%",
                            }}
                          >
                            {/* <div className='drive_photos_div' > */}
                            {/* <div style={{ height: '98%', 
                                                                // width: '15%', 
                                                                // marginLeft: '5%' 
                                                                }} >
                                                                <img className='drive_img' src={drive} ></img>
                                                            </div> */}
                            {/* <div className='drive_input_div' >

                                                                <input
                                                                    type="text"
                                                                    value={folderUrl}
                                                                    onChange={(e) => {
                                                                        setFolderUrl(e.target.value);
                                                                        setIsAutoSave(true);
                                                                    }}
                                                                    placeholder="Paste the Google Drive link"
                                                                    className='drive_input'

                                                                />



                                                            </div> */}

                            {/* </div> */}
                            {checkPermission(["cloud_sync"]) && (
                              <Tooltip title="Sync with cloud">
                                <div className="input_button_div_">
                                  <button
                                    type="button"
                                    className="input_btn_"
                                    onClick={() => {
                                      setS3modal({ show: true });
                                    }}
                                  >
                                    <AiOutlineCloudSync
                                      style={{
                                        color: "white",
                                        fontSize: "30px",
                                      }}
                                    />
                                  </button>
                                </div>
                              </Tooltip>
                            )}
                          </form>
                        </div>
                        <div style={{ marginTop: "20px" }}>
                          {files.length > 0 && (
                            <div>
                              <div className="drive_img_div">
                                {files.map((file, index) => {
                                  const isGLB = file.s3_file
                                    .toLowerCase()
                                    .includes(".glb");

                                  return (
                                    <div
                                      key={index}
                                      className="drive_photo_div_"
                                      draggable
                                      onDragStart={(e) => {
                                        const imageUrl = file.s3_file;
                                        const jsonData = JSON.stringify({
                                          imageUrl,
                                          thumbnailUrl: imageUrl,
                                        });
                                        e.dataTransfer.setData(
                                          "application/json",
                                          jsonData
                                        );
                                        e.dataTransfer.setData(
                                          "text/plain",
                                          jsonData
                                        );

                                        const imgElement =
                                          e.target.tagName === "IMG"
                                            ? e.target
                                            : e.target.querySelector("img");
                                        if (imgElement && imgElement.complete) {
                                          e.dataTransfer.setDragImage(
                                            imgElement,
                                            imgElement.width / 2,
                                            imgElement.height / 2
                                          );
                                        }
                                      }}
                                    >
                                      {isGLB ? (
                                        <div style={{ position: "relative" }}>
                                          <Canvas
                                            key={`preview-${index}-${file.s3_file}`}
                                            camera={{
                                              position: [0, 0, 1],
                                              fov: 50,
                                            }}
                                            gl={{
                                              preserveDrawingBuffer: true,
                                              antialias: true,
                                              alpha: true,
                                              powerPreference:
                                                "high-performance",
                                            }}
                                            style={{
                                              borderRadius: "10px",
                                              width: "150px",
                                              height: "150px",
                                              backgroundColor: "#fff",
                                            }}
                                          >
                                            <ambientLight intensity={3.5} />
                                            <directionalLight
                                              position={[5, 5, 5]}
                                              intensity={2.5}
                                            />
                                            <directionalLight
                                              position={[-5, 5, -5]}
                                              intensity={1.5}
                                            />
                                            <pointLight
                                              position={[0, 10, 0]}
                                              intensity={2.0}
                                            />

                                            {/* Add additional fill light */}
                                            <directionalLight
                                              position={[0, -5, 0]}
                                              intensity={1.0}
                                            />
                                            {!error ? (
                                              <Suspense
                                                fallback={
                                                  <SuspenseHtmlLoader />
                                                }
                                              >
                                                <ErrorBoundary
                                                  fallback={
                                                    <ErrorFallbackModel />
                                                  }
                                                  onError={handleModelError}
                                                >
                                                  <Bounds
                                                    fit
                                                    clip
                                                    observe
                                                    margin={1.2}
                                                  >
                                                    <Model
                                                      key={`preview-model-${index}`}
                                                      imageUrl={file.s3_file}
                                                    />
                                                  </Bounds>
                                                </ErrorBoundary>
                                              </Suspense>
                                            ) : (
                                              <ErrorFallbackModel />
                                            )}
                                          </Canvas>

                                          <div
                                            style={{
                                              position: "absolute",
                                              top: "3px",
                                              right: "6px",
                                            }}
                                            className="3d-icon-container"
                                          >
                                            <Md3dRotation
                                              style={{ fontSize: "23px" }}
                                            />
                                          </div>
                                        </div>
                                      ) : (
                                        <img
                                          src={file.s3_file}
                                          alt={file.name || `media-${index}`}
                                          className="drive_img"
                                        />
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="img-main-box">
                          <div
                            style={{
                              alignItems: "center",
                              marginBottom: "25px",
                              height: "235px",
                              width: "200px",
                              cursor: "pointer",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              className="img-adding-div"
                              onClick={handleImageAddaHandler}
                            >
                              <HiOutlinePlus size={70} color="#092159e4" />
                            </div>
                            <p>{`(${formik?.values?.images.length}/8)`}</p>
                          </div>
                          {(tempImage.show
                            ? tempImage.data
                            : formik?.values?.images
                          )?.map((imgItem, indexImage) => {
                            if (imgItem?.position === "Main") {
                              return <></>;
                            }
                            return (
                              <div
                                style={{
                                  marginBottom: "25px",
                                  height: "235px",
                                  width: "200px",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  ref={containerRef}
                                  style={{
                                    border:
                                      formik?.touched?.images &&
                                      formik?.errors?.images &&
                                      (indexImage ===
                                        formik?.values?.images.length - 2 ||
                                        indexImage ===
                                          formik?.values?.images.length - 1)
                                        ? "1px solid red"
                                        : "",
                                  }}
                                  className="img-upload"
                                  onDragOver={handleDragOver}
                                  onDrop={(e) => handleDrop(e, indexImage)}
                                >
                                  {imgItem?.prevImages || imgItem?.images ? (
                                    // Show image if it's a regular preview
                                    <img
                                      onClick={() =>
                                        setShowEnlargeImage({
                                          show: true,
                                          image: imgItem?.images,
                                          imageIdTitle: "reference-image",
                                          imageIndex: indexImage,
                                          title: "Digital image",
                                          isEdit: true,
                                        })
                                      }
                                      src={
                                        imgItem?.prevImages || imgItem?.images
                                      }
                                      alt="Dropped"
                                      style={{
                                        maxWidth: "100%",
                                        maxHeight: "100%",
                                      }}
                                    />
                                  ) : (
                                    // Show replace div if nothing uploaded yet
                                    <div
                                      onClick={() => handleClick(indexImage)}
                                      className="replace-logo-div"
                                      style={{
                                        ...(indexImage ===
                                        formik?.values?.images?.length - 1
                                          ? { flexDirection: "column" }
                                          : {}),
                                      }}
                                    >
                                      <img
                                        style={{
                                          marginTop:
                                            indexImage ===
                                            formik?.values?.images?.length - 1
                                              ? "22px"
                                              : "0px",
                                        }}
                                        className="replace-logo"
                                        src={replace}
                                        alt="Replace Logo"
                                      />
                                    </div>
                                  )}

                                  <Form.Control
                                    onChange={(e) =>
                                      handleImageChange(indexImage, e)
                                    }
                                    // accept={imgItem?.image_position===".glb" ? '.glb' : '.jpeg,.jpg,.png,'}
                                    type="file"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    className={`reference-image-${indexImage}`}
                                  />
                                  {indexImage <
                                    formik?.values?.images.length - 2 && (
                                    <div
                                      className="delete_icon"
                                      style={{
                                        backgroundColor:
                                          indexImage >=
                                          formik?.values?.images.length - 2
                                            ? "white"
                                            : "#013979",
                                      }}
                                    >
                                      <RiCloseFill
                                        onClick={() =>
                                          imageDeleteHandler(indexImage)
                                        }
                                        size={15}
                                        style={{ strokeWidth: 2 }}
                                        color="white"
                                      />
                                    </div>
                                  )}
                                </div>
                                {/* <div className='index_input_div' style={{}} >

                                                                    <input className='index_input' onChange={(e) => imagePositionChangeHandler(e, indexImage)} value={imgItem?.image_position} />


                                                                </div> */}
                              </div>
                            );
                          })}
                          <div
                            onDragOver={handleDragOver}
                            onDrop={(e) => handleGLBDrag(e)}
                            style={{ width: "200px", marginBottom: "60px" }}
                            className="img-upload"
                          >
                            {formik?.values.tempUrl ||
                            formik?.values.glb_image ? (
                              <div
                                onClick={() => {
                                  noGlb
                                    ? handleGlBClick()
                                    : setShowEnlargeImage({
                                        show: true,
                                        image:
                                          formik.values.tempUrl ||
                                          formik.values.glb_image,
                                        threeDpreview:
                                          formik.values.tempUrl ||
                                          formik.values.glb_image,
                                        imageIdTitle: "reference-image",

                                        title: "Digital image",
                                        isEdit: true,
                                        isExpand: true,
                                      });
                                }}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  background: "#f0f0f0",
                                  position: "relative",
                                }}
                              >
                                <Canvas
                                  style={{
                                    zIndex: 1,
                                  }}
                                  key={`upload-${formik.values.url}`}
                                  camera={{
                                    position: [0, 0, 1],
                                    fov: 50,
                                  }}
                                  gl={{
                                    preserveDrawingBuffer: true,
                                    antialias: true,
                                    alpha: true,
                                    powerPreference: "high-performance",
                                  }}
                                >
                                  <ambientLight intensity={3.5} />
                                  <directionalLight
                                    position={[5, 5, 5]}
                                    intensity={2.5}
                                  />
                                  <directionalLight
                                    position={[-5, 5, -5]}
                                    intensity={1.5}
                                  />
                                  <pointLight
                                    position={[0, 10, 0]}
                                    intensity={2.0}
                                  />

                                  {/* Add additional fill light */}
                                  <directionalLight
                                    position={[0, -5, 0]}
                                    intensity={1.0}
                                  />
                                  <Suspense fallback={<SuspenseHtmlLoader />}>
                                    <ErrorBoundary
                                      key={
                                        formik?.values?.tempUrl ||
                                        formik?.values?.glb_image
                                      } // <-- IMPORTANT
                                      onError={() => {
                                        setNoGlb(true);
                                      }}
                                      fallback={<ErrorFallbackModel />}
                                    >
                                      <Bounds fit clip observe margin={1.2}>
                                        <Model
                                          key={`preview-model`}
                                          imageUrl={
                                            formik?.values?.tempUrl ||
                                            formik?.values?.glb_image
                                          }
                                        />
                                      </Bounds>
                                    </ErrorBoundary>
                                  </Suspense>
                                </Canvas>

                                <div
                                  style={{
                                    position: "absolute",
                                    top: "0",
                                    right: "0",
                                  }}
                                  className="3d-icon-container"
                                >
                                  <Md3dRotation style={{ fontSize: "23px" }} />
                                </div>
                              </div>
                            ) : (
                              <>
                                <div
                                  onClick={() => handleGlBClick()}
                                  className="replace-logo-div"
                                  style={{
                                    flexDirection: "column",
                                  }}
                                >
                                  <img
                                    style={{
                                      marginTop: "22px",
                                    }}
                                    className="replace-logo"
                                    src={replace}
                                    alt="Replace Logo"
                                  />

                                  <p style={{ color: "gray" }}>Add .glb file</p>
                                </div>
                              </>
                            )}
                            <Form.Control
                              onChange={(e) => handleImageGLB(e)}
                              accept={".glb"}
                              // accept={imgItem?.image_position===".glb" ? '.glb' : '.jpeg,.jpg,.png,'}
                              type="file"
                              style={{ display: "none" }}
                              className={`glb-img`}
                            />
                          </div>
                        </div>
                      </div>

                      <Accordion style={{ marginBottom: "70px" }}>
                        <Accordion.Item>
                          <Accordion.Header
                            style={{ borderBottom: "1px solid lightgray" }}
                          >
                            <h6
                              style={{ fontWeight: "600", marginLeft: "-20px" }}
                            >
                              Recommended photography shoot setup
                            </h6>
                          </Accordion.Header>
                          <Accordion.Body>
                            {formikValues?.photography_description ||
                            formikValues?.photo_setup_images?.length > 0 ? (
                              <ul
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "20px",
                                  marginLeft: "-52px",
                                  marginTop: "27px",
                                }}
                              >
                                <li className="field-li row">
                                  <div className="col-md-2">
                                    Photo setup description{" "}
                                  </div>
                                  <div className="col-md-10">
                                    {formikValues?.photography_description}
                                  </div>
                                </li>
                                <li className="field-li row">
                                  <div className="col-md-2">Photo setup</div>
                                  <div
                                    style={{ display: "flex", gap: "10px" }}
                                    className="col-md-10"
                                  >
                                    {formikValues?.photo_setup_images?.map(
                                      (liImage) => {
                                        return (
                                          <div
                                            style={{
                                              height: "100px",
                                              width: "100px",
                                              border:
                                                "1px solid rgb(238, 238, 238)",
                                              borderRadius: "10px",
                                              padding: "5px",
                                            }}
                                          >
                                            <img
                                              onClick={() => {
                                                const reorderedImages = [
                                                  liImage,
                                                  ...formikValues?.photo_setup_images.filter(
                                                    (img) =>
                                                      img.image !==
                                                      liImage.image
                                                  ),
                                                ];

                                                setShowEnlargeImage({
                                                  isEdit: false,
                                                  show: true,
                                                  image: reorderedImages,
                                                  title: "Photo setup",
                                                });
                                              }}
                                              style={{
                                                height: "100%",
                                                width: "100%",
                                                cursor: "pointer",
                                                objectFit: "contain",
                                              }}
                                              src={liImage?.image}
                                              alt="photo-setup"
                                            />
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                </li>
                              </ul>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  marginTop: "50px",
                                }}
                              >
                                <p>No photography shoot setup added yet!</p>
                              </div>
                            )}
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>

                      <div className="submit-btn-row">
                        <Button
                          className="discard-btn"
                          onClick={() => handleBack("discard")}
                        >
                          Discard changes
                        </Button>

                        <Button
                          className="submit-btn"
                          type="submit"
                          disabled={buttonloader}
                        >
                          {buttonloader ? (
                            <SimpleBackdrop />
                          ) : photographyStatus === "photography_complete" ||
                            photographyStatus === "in_photography" ||
                            photographyStatus === "photography_complete" ||
                            photographyStatus === "re_shoot" ? (
                            "Update"
                          ) : (
                            "Submit"
                          )}
                        </Button>
                      </div>
                    </div>
                  </Row>
                </div>
                <Commentdrawer
                  fromlist={fromList}
                  photography={true}
                  id={id}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  toggleDrawer={toggleDrawer}
                />
                <Objecthistorydrawer
                  fromList={fromList}
                  photography={true}
                  id={id}
                  isOpenhistory={isOpenhistory}
                  setIsOpenhistory={setIsOpenhistory}
                  toggleDrawerhistory={toggleDrawerhistory}
                />
              </Form>
            )}
          </Container>
        </div>
        {isOverRide && (
          <OverRideAlert
            setLoading={setLoading}
            setIsOverRide={setIsOverRide}
            isOverideLoad={isOverideLoad}
            overRideCancel={overRideCancel}
            overRideConfirmHandler={overRideConfirmHandler}
          />
        )}

        {showPrompt && (
          <NavigationAlert
            confirmNavigation={confirmNavigation}
            cancelNavigation={cancelDeleteHandler}
          />
        )}
      </section>
    </>
  );
};
export default Objectphotographydetails;
